import yup from '@/libs/yup';

export default yup.object({
    key: yup.string().required(),
    priority: yup.number().required()
});
